<template>
    <v-dialog :model-value="isOpen" opacity = "0.5" persistent>
      <template #default>
        <div class="d-flex justify-center mt-6">
          <v-card
            :width="mobile ? '90%' : '65%'"
            height="86vh"
            color="white"
            elevation="3"
            class="d-flex flex-column"
          >
            <v-toolbar flat density="compact" color="white">
              <div class="d-flex align-center">
                <v-btn icon color="primary" @click="close()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>

              <v-chip variant="tonal" color="primary" v-if="userModel.userId">
                ID: {{ userModel.userId }}
              </v-chip>
      
              <v-spacer />
      
              <v-btn @click="deleteUser()" icon color="primary">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-toolbar>

            <v-divider></v-divider>

            <v-form ref="form" class="card-scroll">
              <v-row dense class="pa-8 flex-grow-1">
                <v-col cols="12" sm="6">
                  <div>
                    <v-text-field
                      v-model="userModel.userName"
                      label="Nome"
                      variant="outlined"
                      color="primary"
                      density="compact"
                      rounded
                      :rules="[v => !!v || 'Campo obrigatório']"
                    />
                  </div>
                </v-col>
                <v-col cols="10" sm="4">
                  <div>
                    <v-text-field
                        v-model="userModel.userPassword"
                        label="Senha"
                        variant="outlined"
                        type="password"
                        color="primary"
                        density="compact"
                        maxlength="24"
                        rounded
                        :disabled="!editPassword && user.isUpdate"
                        :rules="[
                          v => user.isUpdate || !!v || 'Campo obrigatório'
                        ]"
                    />
                  </div>
                </v-col>
                <v-col cols="2" sm="2">
                  <v-btn
                    icon="mdi-pencil"
                    variant="plain"
                    @click="editPassword = true, updatePassword()"
                    :disabled="!user.isUpdate"
                    rounded
                  >
                  </v-btn>
                </v-col>
                <template v-if="!userModel.IsSuperAdmin">
                  <v-col cols="12">
                    <v-sheet >
                      <div class="d-flex align-center mb-4">
                        <v-icon color="primary" class="mr-2" size="default">mdi-cancel</v-icon>
                        <span class="text-subtitle-1 text-primary" style="color: #1F4529;">Permissões</span>
                      </div>
                    </v-sheet>
                    <v-divider class="mb-4"></v-divider>
                  </v-col>
                  <v-col
                    cols="12" sm="3"
                    v-for="p in user.permissionsMap.filter(p => !p.section)"
                    :key="p.code"
                  >
                    <v-switch
                      :label="p.label"
                      color="primary"
                      :model-value="hasPermission(p.code)"
                      @update:model-value="togglePermission(p.code, $event)"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-sheet class="pl-4">
                      <div class="d-flex align-center mb-4">
                        <v-icon color="primary" class="mr-2" size="small">mdi-page-previous-outline</v-icon>
                        <span class="text-subtitle-2 text-primary" style="color: #1F4529;">Relatórios</span>
                      </div>
                    </v-sheet>
                    <v-divider></v-divider>
                  </v-col>
                  <v-col
                    cols="12" sm="3"
                    v-for="p in user.permissionsMap.filter(p => p.section === 'report')"
                    :key="p.code"
                  >
                    <v-switch
                      :label="p.label"
                      color="primary"
                      :model-value="hasPermission(p.code)"
                      @update:model-value="togglePermission(p.code, $event)"
                    />
                  </v-col>
                </template>
              </v-row>
            </v-form>
            <v-card-actions class="mt-n6 pb-6 pr-6">
              <div class="d-flex flex-column flex-md-row w-100 justify-end">
                <v-btn
                  rounded
                  variant="flat"
                  @click="close()"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  rounded
                  color="primary"
                  class="ml-2"
                  variant="elevated"
                  @click="save()"
                >
                  Salvar
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </div>
      </template>
    </v-dialog>
</template>


<script>
import { useDisplay } from 'vuetify'

export default {
  setup () {
    const { mobile } = useDisplay()
    return { mobile }
  },
  data: () => ({
    editPassword: false,
    userId: '',
  }),
  computed: {
    user: {
      get() {
        return this.$store.state.user
      }
    },
    userModel: {
      get() {
          return this.$store.state.user.user
      },
    },
    isOpen: {
      get() {
        return Boolean(this.$route.params.userId || this.$route.name == 'NewUser')
      },
      set(value) {
        if (!value) {
          this.$router.push({ name: 'UserGrid' })
        }
      }
    }
  },
  methods: {
    async save() {
      const { valid } = await this.$refs.form.validate()
      if (!valid) return
      
      const success = await this.$store.dispatch("user/save")
      if (success) {
        this.$store.commit('user/setShouldReload', true)
        this.close()
      }
    },
    close() {
      this.$router.push({ name: 'UserGrid' })
    },
    async deleteUser() {
      const confirmed = await this.$store.dispatch('systemDialogOptions/confirm', null, { root: true })
      if (!confirmed) 
          return false
        
      const success = await this.$store.dispatch("user/delete")
      if (success) {
        this.$store.commit('user/setShouldReload', true)
        this.close()
      }
    },
    updatePassword() {
      this.userModel.userPassword = ''
    },
    hasPermission(code) {
      return this.userModel.permissions?.includes(code)
    },
    togglePermission(code, enabled) {
      if (enabled) {
        if (!this.userModel.permissions?.includes(code)) {
          this.userModel.permissions?.push(code)
        }
      } else {
        this.userModel.permissions =
          this.userModel.permissions?.filter(p => p !== code)
      }
    }
  },
  watch: {
    '$route.params.userId': {
      immediate: true,
      async handler(id) {
        if(id) {
          await this.$store.dispatch('user/find', id)
        } else {
          this.$store.commit('user/initForm')
        }
      }
    }
  }
}
</script>


<style>
.card-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
}
</style>